import React from 'react';
import { useQuery } from 'react-admin';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import * as R from 'ramda';
import moment from 'moment-timezone';

const ZoomAttendanceField = ({ date, record, isAbsent, timezone }) => {
	const { data, loading, error } = useQuery({
		type: 'getManyReference',
		resource: 'zoom_attendance',
		payload: {
			search: [
				{
					$match: {
						$and: [
							{ student_id: record.id },
							{ session_date: moment(date).format('YYYY-MM-DD') },
						],
					},
				},
			],
			pagination: {
				perPage: 1000,
			},
			sort: { field: 'join_time', order: 'ASC' },
		},
	});

	if (loading) {
		return (
			<Box display="flex" alignItems="center">
				<CircularProgress size={20} />
			</Box>
		);
	}

	if (error && error.message !== 'No attendance data') {
		return (
			<Typography
				variant="body2"
				color="error"
				sx={{
					textAlign: 'right',
				}}
			>
				Error loading zoom connections
			</Typography>
		);
	}

	if (isAbsent) {
		return (
			<Typography
				variant="body2"
				color="textSecondary"
				sx={{
					textAlign: 'right',
				}}
			>
				No access
			</Typography>
		);
	}

	if (!data || R.isEmpty(data)) {
		return (
			<Typography
				variant="body2"
				color="textSecondary"
				sx={{
					textAlign: 'right',
				}}
			>
				No zoom connections
			</Typography>
		);
	}

	const formatTime = (isoString) => {
		if (!isoString) return '--';
		try {
			return timezone
				? moment.tz(isoString, timezone).format('HH:mm')
				: moment(isoString).format('HH:mm');
		} catch (e) {
			return moment(isoString).format('HH:mm');
		}
	};

	const sessions = R.pipe(
		R.map(
			(attendance) =>
				`Access: ${formatTime(attendance.join_time)} Exit: ${formatTime(
					attendance.leave_time
				)}`
		)
	)(data);

	return (
		<Box>
			<Typography
				variant="body2"
				color="textSecondary"
				sx={{
					textAlign: 'right',
				}}
			>
				{sessions.join(' | ')}
			</Typography>
		</Box>
	);
};

export default ZoomAttendanceField;
